import getStore from '../store'



// API_URL fetched from environment
export const API_ROOT = process.env.REACT_APP_API_URL



// Fetches an API response.
// This makes every API response have the same shape, regardless of how nested it was.
export function callApi(callAPI) {
	// Check if array of calls
	if (callAPI instanceof Array) {
		return Promise.all(callAPI.map((item) => callApi(item)))
	}
	// Check endpoint
	const endpoint = callAPI.endpoint;
	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.')
	}
	// Make full url
	const fullUrl = (endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint
	// Create fetch options
	const init = {
		method: callAPI.method || 'GET',
		headers: {},
		body: JSON.stringify(callAPI.body)
	}
	// Add token
	if (getStore().getState().session.token) {
		callAPI.token = getStore().getState().session.token
	}
	// Add headers
	if (callAPI.body) {
		init.headers['Content-Type'] = callAPI.contentType || 'application/json'
	}
	if (callAPI.token) {
		init.headers['Api-Token'] = callAPI.token
	}
	// Fetch
	return fetch(fullUrl, init).then(response =>
		response.json().then(json => {
			if (!response.ok) {
				json.status = response.status;
				return Promise.reject(json)
			}
			if (callAPI.after) {
				return callAPI.after(json, getStore().getState())
			}
			return json
		})
	)
}



export function getAuthHeaders() {
	return { 'Api-Token': getStore().getState().session.token }
}


// WEBPACK FOOTER //
// ./src/services/fetchService.js